module.exports = "../static/media/banner_short.d66a633f.png";